import { http } from "helpers/Http";
import logger from "../../../../components/Logger";

const path = 'services/api/requests/UserOrders/index.ts'
export async function postLogin(loginInfo: any): Promise<any> {
    const url = `users/login?current_app_id=7f43b71cf80b111eaf108db878edbad8e84162e2bd6001a565a73500b432efca`;
    const data = http.post(url, loginInfo).then((response) => response.data);

    logger.log("************************************************************************************")
    logger.log(`| FILE: ${path} | METHOD: postLogin`)
    logger.log("| url: ", url)
    logger.log("| loginInfo: ", loginInfo)
    logger.log("| promise returned ", data)
    logger.log("************************************************************************************")


    return data;
}


export async function postLoginGuest(loginInfo: any): Promise<any> {
    const url = `users/login`;
    const data = http.post(url, loginInfo).then((response) => response.data);
    return data;
}

export async function postResetPassword(resetPasswordBody: any): Promise<any> {
    const url = `users/password/reset`;
    const data = http.post(url, resetPasswordBody).then((response) => response.data);
    return data;
}